'use strict'

export let norwegian={
  general: {
    title: "Risiko",
    probability: "Sannsynlighet",
    impact: "Konsekvens",
    add: "Ny risiko",
    approach: "Tilnærming",
    riskStatement: "Risikosetning",
    status: "Status",
    statement: {
      if: "Siden det er",
      cause: "årsak",
      thereIsA: "så er det",
      riskTypeOptions: {
        Threat: "fare",
        Opportunity: "mulighet"
      },
      that: "for at",
      event: "hendelse",
      whichWouldResultIn: "noe som kan medføre at",
      effect: "effekt"
    }
  },
  views: {
    identify: {
      title: "Identifisere",
      columns: {
        id: "Id",
        title: "Tittel",
        category: "Kategori",
        cause: "Årsak"
      }
    },
    followUp: {
      title: "Følge opp",
      columns: {
        id: "Id",
        title: "Tittel",
        solution: "Tiltak",
        ownerAndActionee: "Eier / utfører"
      }
    },
    present: {
      title: "Presentasjon",
      menu: {
        title: "Risikovalg",
        backToRiskRegister: "Til risikoregister",
        allRiskItems: "Vis alle risiki",
        allOpenRiskItems: "Vis alle åpne riski",
        editRiskItem: "Rediger risiko",
        selectRiskItem: "Velg risiko",
        viewFullScreen: "Vis i fullskjerm",
        viewPDF: "Vis som PDF",
      }
    }
  },
  identify: {
    title:"Identifiser",
    fields: {
      title: {
        title:"Tittel",
        description:"Beskrivende risikotittel",
        help:"Kort oppsummering av risikoen",
      },
      owner: {
        title:"Risikoeier",
        description:"Personen som skal håndtere risikoen",
        help:"Hvem bør sørge for at denne risikoen vurderes, planlegges og tiltak gjennomføres?",
      },
      type: {
        title:"Type",
        help:"Trussel er brukt til å beskrive en usikker hendelse som kan ha en negativ innvirkning - Mulighet for en hendelse som kan ha en gunstig innvirkning",
        options:{
          Threat:"Trussel",
          Opportunity:"Mulighet"
        }
      },
      category: {
        title:"Kategori",
        help:"Hvilket ytelsesaspekt vil trolig ha størst betydning hvis risikoen materialiseres?",
        options: {
          Time:"Tid",
          Cost:"Kostnad",
          Scope:"Omfang",
          Quality:"Kvalitet",
          Benefit:"Gevinst",
          Risk:"Risiko"
        }
      },
      cause: {
        title:"Årsak",
        description:"Beskriv kilden til risikoen. Denne delen av risikosetningen er: siden det er <årsak>",
        help:"Hva vil føre til at hendelsen oppstår? Hva er hendelsen eller situasjonen som gir opphav til risikoen. Eksempel: Teknisk kravdokumentasjon er ikke fullført",
      },
      event: {
        title:"Hendelse",
        description:"Identifiser usikkerhetsområdet. Denne delen av risikosetningen er: så er det en fare / en mulighet for at <hendelse>",
        help:"Hva er usikkerhetsområdet? Eksempel: Det tekniske designarbeidet kan ikke starte",
      },
      effect: {
        title:"Effekt",
        description:"Forklar virkningen(e) på målene. Denne delen av risikosetningen er: som kan medføre at <effekt>",
        help:"Hvis denne risikoen materialiseres, hvordan vil den påvirke målene? Eksempel: Betydelig forsinkelse",
      }
    }
  },
  assess: {
    title:"Vurdere",
    fields: {
      assessment: {
        categories: {
          inherent: {
            title: "Opprinnelig"
          },
          residual: {
            title: "Gjenstående"
          }
        },
        fields: {
          impact: {
            title:"Konsekvens",
            help:`Hva er effektnivået på målene?

              Alvorlig: Kritiske mål vil ikke bli oppnådd
              Vesentlig: Oppgitte mål vil falle under akseptabelt nivå
              Moderat: Oppgitte mål vil falle under målsetningen, men over minimum akseptable nivåer
              Mindre: Oppgitte mål vil falle under målsetningen, men godt over minimum akseptable nivåer
              Ubetydelig: Ingen eller liten innvirkning på å oppnå mål`,
            options: {
              1: "Ubetydelig",
              2: "Mindre",
              3: "Moderat",
              4: "Signifikant",
              5: "Alvorlig"
            }
          },
          probability: {
            title:"Sannsynlighet",
            help:`Hva er sannsynligheten for denne risikoen?

              80-99% Svært sannsynlig
              60-79% Sannsynlig
              40-59% mulig
              20-39% usannsynlig
              1-19% Svært usannsynlig`,
            options: {
              1: "Veldig usannsynlig",
              2: "Usannsynlig",
              3: "Mulig",
              4: "Sannsynlig",
              5: "Veldig sannsynlig"
            }
          }
        }
      },
      impact: {
        title:"Konsekvens",
        help:`Hva er effektnivået på målene?

           Alvorlig: Kritiske mål vil ikke bli oppnådd
           Vesentlig: Oppgitte mål vil falle under akseptabelt nivå
           Moderat: Oppgitte mål vil falle under målsetningen, men over minimum akseptable nivåer
           Mindre: Oppgitte mål vil falle under målsetningen, men godt over minimum akseptable nivåer
           Ubetydelig: Ingen eller liten innvirkning på å oppnå mål`,
        options: {
          1: "Ubetydelig",
          2: "Mindre",
          3: "Moderat",
          4: "Signifikant",
          5: "Alvorlig"
        }
      },
      probability: {
        title:"Sannsynlighet",
        help:`Hva er sannsynligheten for denne risikoen?

          80-99% Svært sannsynlig
          60-79% Sannsynlig
          40-59% mulig
          20-39% usannsynlig
          1-19% Svært usannsynlig`,
        options: {
          1: "Veldig usannsynlig",
          2: "Usannsynlig",
          3: "Mulig",
          4: "Sannsynlig",
          5: "Veldig sannsynlig"
        }
      },
      proximity: {
        title:"Nærhet",
        help:"Hvor nært er det at hendelsen utløse risikoen: Umiddelbart, dager, uker, måneder eller en bestemt dato?"
      }
    }
  },
  plan: {
    title:"Planlegge",
    fields: {
      response: {
        title:"Tiltakstype",
        help:`Hvilken respons er proporsjonal med risikoen og gir valuta for pengene?
          Unngå = gjør en endring slik at trusselen ikke lenger kan skje eller har ingen innvirkning
          Redusere = redusere sannsynligheten med en eller annen form for kontroll og/eller reduser effekten hvis den oppstår
          Overføre = En tredjepart tar ansvar for deler av den økonomiske effekten
          Akseptere = Beslutning er truffet for å beholde risikoen
          Dele = del gevinst eller smerte med partner
          Utnytte = sørg for at muligheten vil skje
          Forbedre = øke sannsynligheten for at hendelsen oppstår, øke virkningen hvis den skulle oppstå
          Beredskapsplan = har reserveplaner for å håndtere påvirkning dersom risikoen oppstår`,
        options:{
          Avoid:"Unngå (trussel)",
          Reduce: "Redusere (trussel)",
          Transfer: "Overføre (trussel/mulighet)",
          Accept: "Akseptere (trussel/mulighet)",
          Share: "Dele (trussel/mulighet)",
          Exploit: "Utnytte (mulighet)",
          Enhance: "Forbedre (mulighet)",
          ContingencyPlan: "Beredskapsplan (trussel/mulighet)"
        }
      },
      actionee: { title:"Utførende", help:"Hvem vil gjennomføre handlingene?"},
      action: { title:"Tiltak", help:"Hvilke tiltak vil bli tatt for å løse risikoen?"}
    }
  },
  implement: {
    title:"Iverksette",
    fields: {
      status: {
        title:"Status",
        options:{
          Active: "Aktiv",
          Closed: "Lukket"
        }
      },
      comments: { title:"Kommentarer", help:"Kommentarer eller gjeldene status"}
    }
  },
  riskRegister: {
    title: "Risikoregister",
    description:"Risikoregisteret gir en oversikt over identifiserte risiki, inkludert deres status og historie. Risikoregisteret brukes til å dokumentere og vedlikeholde informaiton om all identifisert usikkerhet, både trussler og muligheter",
    description2:"Legg til en ny risiko ved å velge 'Ny risiko' under. Du kan vedlikeholde en risiko ved å velge den i tabellen under. Hvis sannsynligheten for en risiko blir så og si 100%, bør du konvertere den til en sak i saksregisteret (under Endring)"
  },
  riskManagementApproach: {
    title: "Tilnærming til risikoledelse",
    description:"Tilnærming til risikoledelse beskriver hvordan risiko skal håndteres og hvor mye risiko man ønsker å ha.",
    fields: {
      process: {
        title: "Prosess og prosedyrer",
        help: `Vil prosjektet ha regler, rutiner eller prosesser på plass som sikrer at risiko identifiseres, vurderes og håndteres?
          Finnes det standard prosedyrer som skal følges for å sikre at risiko blir identifisert, vurdert, planlagt og tiltak ivertsatt? Hvordan er det med planlagte avvik fra disse prosedyrene? Hvis ja, hvorfor?
          Hvordan skal vi sørge for at prosessen for risikostyring blir fulgt opp?
          Vil prosedyren for risikoledelse eksplisitt adressere informasjonssikkerhetsrisiko knyttet til klassifisert informasjon eller datasikkerhet?`,
        description: "Beskriv hvordan risiko vil bli: identifisert, vurdert, planlagt og iverksatt"
      },
      tools: {
        title: "Verktøy og teknikker",
        help: `Hvilke identifikasjonsteknikker skal benyttes (gjennomgangsleksjoner, sjekklister, idémyldring, arbeidsmøte, workshops, oppdelingsstrukturer)?
          Eventuelle estimeringsteknikker som skal brukes (sannsynlighetstrær, forventet verdi, risikomodeller)?
          Hvilke verktøy vil bli brukt til å håndtere risiko?`,
        description: "Beskriv verktøy og teknikker som skal brukes i risikostyring av dette prosjektet"
      },
      reporting: {
        title: "Rapportering",
        help: `Når vil risiko bli rapportert? Hvor vil risikoen bli rapportert og hvem vil motta risikorapportene`,
        description: "Beskriv hvilke rapporter som skal produseres, deres formål, timing og mottakere"
      },
      timing: {
        title: "Tidsagivelse av aktiviteter",
        help: `Når vil risikostyringsaktiviteter utføres?
          Skal det utføres spesifikke aktiviteter i Initieringsetappen eller i begynnelsen / slutten av etapper?`,
        description: "Beskriv når risikostyringsaktiviteter vil bli utført"
      },
      roles: {
        title: "Roller og ansvar",
        help: `Hvem sørger for at risikoen blir notert (identifisert), vurdert, planlagt og implementert? Hvem godkjenner en tilbakemelding? Følges det en rutine for å angi hvem som eier og kommuniserer en risiko? Hvem kommuniserer hva?
          Hvem ringer og organiserer risikostyringsaktiviteter og vurderinger?`,
        description: "Definer roles og ansvar for risikoaktivitetene"
      },
      tolerance: {
        title: "Toleranse for risiko",
        help: `Hva er holdningen til å ta risiko - er risikoappetitten høy eller er den lav?
          Hvilket usikkerhetsnivå er OK? Er det områder hvor stor usikkerhet er akseptert og annen usikkerhet må være lav?
          Når skal en risiko bli eskalert?`,
        description: "Definer risikoappetiten og når en risiko skal eskaleres"
      },
      budget: {
        title: "Risikobudsjett",
        help: `Forventer vi å avsette tid, ressurser eller penger til å takle risiko?
          Hvis ikke, hvor vil ressursene for å håndtere risiko komme fra?`,
        description: "Beskriv  risikobusjettet, hvis det finnes, og hvordan det skal brukes."
      }
    }
  }
};



// WEBPACK FOOTER //
// ./views/risk/labels/norwegian.js